module.exports = __webpack_public_path__ + "img/Heart.4ba4f116.svg";